module.exports = __webpack_public_path__ + "media/recipes/40-27feb9ac.png";